import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import LocationField from 'components/location/picker/LocationField';
import { H5 } from 'components/typography/Headers';
import { useCurrentUser } from 'providers/cache/cachedDataHooks';
import { useNotification } from 'providers/NotificationProvider';
import { userService } from 'services/user/userService';
import { UserLocationDto } from 'services/user/userService.dto';
import { fromUserLocation } from 'services/utils/location/locationPicker.utils';
import { LocationDetailsDto } from 'services/utils/location/locationService.dto';

const LocationInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 360px;
  margin-top: 24px;
  gap: 16px;
`;

export const UserLocation = () => {
  const { currentUser, refreshCurrentUser } = useCurrentUser();
  const { t } = useTranslation();
  const { showNotification } = useNotification();

  const handleLocationChange = (location?: LocationDetailsDto) => {
    if (!location) return;

    const locationPayload: UserLocationDto = {
      lat: location.latitude,
      lon: location.longitude,
      country: location.countryCode === 'US' ? 'United States' : location.countryCode,
      state: location.state,
      city: location.city,
      zip: location.zipCode,
      source: location.locationSource,
    };

    userService
      .setUserLocation(locationPayload)
      .then(() => {
        refreshCurrentUser?.();
        showNotification({ title: t('myProfile:location.success'), type: 'success' });
      })
      .catch(() =>
        showNotification({
          title: t('myProfile:location.error'),
          type: 'error',
        })
      );
  };

  return (
    <LocationInputContainer>
      <H5>{t('myProfile:location.input-header')}</H5>
      <LocationField
        value={fromUserLocation(currentUser?.location)}
        onChange={handleLocationChange}
        placeholder={t('myProfile:location.set-location')}
      />
    </LocationInputContainer>
  );
};
